<template>
  <div>
    <div>
      <div>
        <b-button
          class="mb-4"
          size="sm"
          @click.prevent="showLastOccurrenceAttachments()"
        >
          <i class="tim-icons icon-camera-18 mb-1 mr-2"></i>
          {{ getLabelLastOccurrenceAttachments }}
        </b-button>
      </div>
      <div v-if="isShowingLastOccurrenceAttachments" class="mb-4">
        <h4>{{ this.$t('tracking.cargo.lastOccurrenceAttachments') }}</h4>
        <cargo-occurrence-attachments
          :model="model"
          :readonly="true"
          :occurrence-type-id="6"
        >
        </cargo-occurrence-attachments>
        <cargo-occurrence-attachments
          :model="model"
          :readonly="true"
          :occurrence-type-id="7"
        >
        </cargo-occurrence-attachments>
      </div>

      <fullscreen-sidebar ref="fullscreenSidebar">
        <template v-slot:content>
          <img :src="attachmentUrl" class="fullscreen-sidebar-img" />
        </template>
      </fullscreen-sidebar>
    </div>
  </div>
</template>

<script>
import CargoOccurrenceAttachments from "@/components_rms/tracking/cargo/CargoOccurrenceAttachments.vue";
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";

export default {
  name: "CargoOccurrencesAttachments",
  components: {
    CargoOccurrenceAttachments,
    FullscreenSidebar,
  },
  props: {
    model: Object,
    readonly: Boolean,
  },
  data: function () {
    return {
      attachmentUrl: "",
      isShowingLastOccurrenceAttachments: false,
    };
  },
  computed: {
    getLabelLastOccurrenceAttachments() {
      if (this.isShowingLastOccurrenceAttachments)
        return this.$t("tracking.cargo.lastOccurrenceAttachmentsHide");
      return this.$t("tracking.cargo.lastOccurrenceAttachmentsShow");
    },
  },
  methods: {
    async loadImg() {
      if (this.model) {
        this.$api
          .request({
            url: `${this.$store.state.urlTracking}/v1/cargo/attachment/${this.model.cargoId}/6`,
            method: "GET",
            responseType: "arraybuffer", //important
          })
          .then((response) => {
            this.attachmentUrl = window.URL.createObjectURL(
              new Blob([response.data], {
                type: response.headers["content-type"],
              })
            );
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              console.log(error.response.data.errors);
            }
          });
      }
      return "";
    },
    showLastOccurrenceAttachments() {
      this.isShowingLastOccurrenceAttachments =
        !this.isShowingLastOccurrenceAttachments;
      // this.attachmentUrl = "";
      // this.loadImg();
      // this.$refs.fullscreenSidebar.open();
    },
  },
};
</script>
